import React, { useEffect, useState } from 'react';
import { AppModal, AppRemixIcon, AppNoInfo } from '@/layout/AppComponents';
import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import EmailNotificationSettings from '../../EmailNotifications/EmailNotificationSettings';
import colors from '../../../../../../constants/colors';
import Translator from '../../../../../components/helpers/Translator';
import ApplicableDateBlock from '../CardElements/ApplicableDateBlock';

const InformationTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const poLevel2 = useSelector(
    (state) =>
      state.currentPage?.plantObligationLevels?.level2?.[plantObligationID]
  );
  const permissions = useSelector((s) => s.module[moduleBridgeHex].permissions);
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex].userBridge
  );
  const [information, setInformation] = useState();
  const [debugCounter, setDebugCounter] = useState(0);
  const [
    showCustomNotificationModal,
    setShowCustomNotificationModal,
  ] = useState(false);
  const [showLastModificationModal, setShowLastModificationModal] =
    useState(false);

  useEffect(() => {
    if (debugCounter === 7) {
      setDebugCounter(0);
      alert(plantObligationID);
    }
  }, [debugCounter]);

  // > LOAD INFORMATION TAB
  const loadInformationTab = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_tab_information"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };
  useEffect(() => {
    loadInformationTab().then((r) => {
      setInformation(r);
    });
  }, []);
  // < LOAD INFORMATION TAB

  if (!information) return <AppNoInfo minHeight={300} />;

  return (
    <InformationTabContainer>
      <div>
        <h3 className="mb-2">{`${poLevel2?.obligation?.category} / ${poLevel2?.obligation?.subcategory} - ${poLevel2?.obligation?.note}`}</h3>
        <Scrollbars style={{ height: '340px', paddingRight: '10px' }}>
          {poLevel2?.obligation?.applicableDate && (
            <ApplicableDateBlock plantObligationID={plantObligationID} />
          )}
          {poLevel2?.obligation?.hasFormat ? (
            <div
              dangerouslySetInnerHTML={{
                __html: poLevel2?.obligation?.obligationVersion?.obligation,
              }}
            />
          ) : (
            <div style={{ whiteSpace: 'pre-line' }}>
              {poLevel2?.obligation?.obligationVersion?.obligation}
            </div>
          )}

          {poLevel2?.obligation?.subObligations.length > 0 && (
            <h3 className="mt-5 mb-0">Nota:</h3>
          )}

          <ul className="pl-3 mt-2">
            {poLevel2?.obligation.subObligations.map((so, i) => (
              <li key={i}>
                <p className="text-primary">{so.name}</p>
                <div
                  className="pr-2"
                  dangerouslySetInnerHTML={{
                    __html: so.subObligation,
                  }}
                />
              </li>
            ))}
          </ul>
        </Scrollbars>
      </div>
      <InformationRight>
        <Scrollbars style={{ height: '385px', paddingRight: '10px' }}>
          {permissions?.gcl?.module?.plant?.calendar
            ?.customEmailNotifications &&
            userBridgePermissions?.permissions?.email && (
              <>
                <span
                  className="btn btn-outline-light btn-block btn-sm mb-2"
                  onClick={() => setShowCustomNotificationModal(true)}
                >
                  <Translator
                    file="module-legalCompliance"
                    name="modify.notifications"
                  />
                </span>
                <AppModal
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="modify.notifications"
                    />,
                  )}
                  show={showCustomNotificationModal}
                  size="lg"
                  onClose={() => setShowCustomNotificationModal(false)}
                >
                  <EmailNotificationSettings
                    type="PlantObligation"
                    element={plantObligationID}
                    onUpdate={() => setShowCustomNotificationModal(false)}
                  />
                </AppModal>
              </>
            )}
          <h4>{`ID: ${poLevel2?.obligation?.id}`}</h4>
          <h4
            onClick={() => setDebugCounter(debugCounter + 1)}
          >{`CODE: ${poLevel2?.obligation?.hex || '------'}`}</h4>
          {information?.obligation?.lastModificationDate && (
            <>
              <h4>
                <Translator
                  file="module-legalCompliance"
                  name="signup.modification.date"
                  variables={{
                    date: information.obligation.lastModificationDate.date,
                  }}
                />
                {information?.obligation?.lastModificationDate?.comment && (
                  <AppRemixIcon
                    icon="chat-3"
                    className="ml-1 mr-1 pointer"
                    filled
                    color={colors.primaryLight}
                    onClick={() => setShowLastModificationModal(true)}
                  />
                )}
              </h4>
              {information?.obligation?.lastModificationDate?.comment && (
                <AppModal
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="signup.modification.comment"
                    />,
                  )}
                  show={showLastModificationModal}
                  onClose={() => setShowLastModificationModal(false)}
                >
                  {information?.obligation?.lastModificationDate?.comment}
                </AppModal>
              )}
            </>
          )}
          {poLevel2?.obligation?.obsoleteDate && (
            <h4>{`${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="obsolete.date.from"
              />,
            )} : ${poLevel2.obligation.obsoleteDate}`}</h4>
          )}
          {poLevel2?.obligation?.applicableDate && (
            <h4>{`${ReactDOMServer.renderToString(
              <Translator
                file="module-legalCompliance"
                name="applicable.date.from"
              />,
            )} : ${poLevel2.obligation.applicableDate}`}</h4>
          )}
          <h4>
            <Translator file="location" name="location.title" />:
          </h4>
          <ul>
            {information?.obligation?.locations.map((loc) => (
              <li key={loc.id}>
                <h4>{loc.name}</h4>
              </li>
            ))}
          </ul>
          {information.layouts && information.layouts.length > 0 && (
            <>
              <h4>
                <Translator file="module-legalCompliance" name="layout" />:
              </h4>
              <ul>
                {information.layouts.map((ly, i) => (
                  <li key={ly}>
                    <h4>{ly}</h4>
                  </li>
                ))}
              </ul>
            </>
          )}
          {information.categoryGroups &&
            information.categoryGroups.length > 0 && (
              <>
                <h4>
                  <Translator
                    file="module-legalCompliance"
                    name="category.groups"
                  />
                  :
                </h4>
                <ul>
                  {information.categoryGroups.map((cg, i) => (
                    <li key={cg}>
                      <h4>{cg}</h4>
                    </li>
                  ))}
                </ul>
              </>
            )}
          {information.classifiedPlants &&
            information.classifiedPlants.length > 0 && (
              <>
                <h4>
                  <Translator
                    file="module-legalCompliance"
                    name="classified.plants"
                  />
                  :
                </h4>
                <ul>
                  {information.classifiedPlants.map((cp, i) => (
                    <li key={cp}>
                      <h4>{cp}</h4>
                    </li>
                  ))}
                </ul>
              </>
            )}
        </Scrollbars>
      </InformationRight>
    </InformationTabContainer>
  );
};
export default InformationTab;

const InformationTabContainer = styled.div`
  display: grid;
  grid-template-columns: 0.8fr 0.2fr;
  height: 385px;
  padding: 1rem;
  overflow: hidden;
`;

const InformationRight = styled.div`
  border-left: 1px solid #ddd;
  padding: 10px;
`;
